import { Events } from "./logEvent.types";
import * as ExcelJS from "exceljs";

export const getEventsListing = async (eventObj: Events) => {
  const values: { Name: string; Action: string | null }[] = Object.values(
    eventObj,
  ).map((item) => {
    return { Name: item.eventName, Action: item.params.action };
  });

  // Generate Markdown
  const headers = Object.keys(values[0]);
  const markdownRows = values.map(
    (item) =>
      `| ${headers
        .map((header) => item[header as keyof typeof item])
        .join(" | ")} |`,
  );
  const markdown = `| ${headers.join(" | ")} |\n| ${headers
    .map(() => "---")
    .join(" | ")} |\n${markdownRows.join("\n")}`;

  // Generate blob for download
  const element = document.createElement("a");
  const file = new Blob([markdown], { type: "text/markdown" });
  element.href = URL.createObjectURL(file);
  element.download = "ReactEvents.md";
  document.body.appendChild(element);

  // Generate excel for download using ExcelJS
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("EventsList");

  // Add headers
  worksheet.columns = headers.map((header) => ({
    header: header,
    key: header,
    width: 20,
  }));

  // Add data rows
  values.forEach((row) => {
    worksheet.addRow(row);
  });

  // Generate buffer and create blob for download
  const buffer = await workbook.xlsx.writeBuffer();
  const excelBlob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const excelElement = document.createElement("a");
  excelElement.href = URL.createObjectURL(excelBlob);
  excelElement.download = "ReactEvents.xlsx";
  document.body.appendChild(excelElement);

  // Trigger download
  element.click();
  console.log("Markdown file created successfully");
  excelElement.click();
  console.log("Excel file created successfully");

  // Clean up
  document.body.removeChild(element);
  document.body.removeChild(excelElement);
};
